module.exports = __webpack_public_path__ + "static/img/353.6af59d1.png";